import React, { useCallback, useEffect, useMemo, useState } from "react"
import DataTable from 'react-data-table-component';
import 'styled-components';
import { Badge, Button, Form, Row } from "react-bootstrap";
import { isNullOrUndefined } from "../../utils/functionsUtils";
import { FiZap } from 'react-icons/fi';
import { useDispatch, useSelector } from "react-redux";
import { assignOperatorActions } from "../../redux/reducers/assignOperatorReducer";

const extractMessage = (data) => {

    if (Array.isArray(data)) {
        return data.map(error => error.message).join(' ')
    }

    if (isNullOrUndefined(data)) return 'N/A';
    if (data?.reason) {
        return data?.reason;
    }
    if (data.errors && Array.isArray(data.errors) && data.errors.length > 0) {
        return data.errors.map(error => error.message).join(' ');
    }

    return 'N/A';
};

function convertArrayOfObjectsToCSV(array) {
    let result;

    const columnDelimiter = ',';
    const lineDelimiter = '\n';
    const keys = Object.keys(
        {
            "usuario_name": "SUPER ADMIN",
            "idaddress": "822029",
            "company_name": "FEDEX MX",
            "cur_status": "En Curso",
            "intents": 3,
            "data_response": {
                "reason": "Ya tiene un operador asignado",
                "idAddress": 822029
            },
            "created_at": "2024-02-07T19:48:56.971Z"
        }
    );

    const keyNames = ["Usuario", "ID_address", "Operador", "Estado", "Intentos", "Respuesta", "Fecha"]

    result = '';
    result += keyNames
    result += lineDelimiter;

    array.forEach(item => {
        let ctr = 0;
        keys.forEach(key => {
            if (ctr > 0) result += columnDelimiter;

            if (key === 'data_response') {
                item[key] = extractMessage(item[key])
            }

            result += item[key];

            ctr++;
        });
        result += lineDelimiter;
    });

    return result;
}

const Export = ({ onExport }) => <Button size="sm" onClick={e => onExport(e.target.value)}>Exportar CSV</Button>;
let interval = null;
export const ProgressDetail = ({activeTab, handleDetail, parent}) => {

    const dispatch = useDispatch();
    const { allAssignmentData, processingGetAllAssignment } = useSelector(
        (state) => state.assignOperatorState
    );

    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [totalRows, setTotalRows] = useState(10);
    const [filterText, setFilterText] = useState('');
    const [isActive, setIsActive] = useState(false);

    const [intervalDuration, setIntervalDuration] = useState('60000');

    const downloadCSV = (array) => {
        const link = document.createElement('a');
        let csv = convertArrayOfObjectsToCSV(array);
        if (csv == null) return;

        const filename = 'export.csv';

        if (!csv.match(/^data:text\/csv/i)) {
            csv = `data:text/csv;charset=utf-8,${csv}`;
        }

        link.setAttribute('href', encodeURI(csv));
        link.setAttribute('download', filename);
        link.click();
    }
    const handlePerRowsChange = async (newPerPage, page) => {
        setPerPage(newPerPage);
        setPage(page);
        await getData(page, newPerPage);
    };

    const actionsMemo = useMemo(() => {
        if (!allAssignmentData || allAssignmentData.length === 0) return ''
       return <Export onExport={() => downloadCSV(filteredData)}/>
    },[allAssignmentData]);

    const filteredData = useMemo(() => {
        if (!allAssignmentData) return [];
        if (!filterText) return allAssignmentData;
        return allAssignmentData.filter(item =>
            Object.keys(item).some(key => !isNullOrUndefined(item[key]) ? item[key].toString().toLowerCase().includes(filterText.toLowerCase()) : false
            )
        );
    }, [allAssignmentData, filterText]);

    const getData = useCallback(async () => {
        dispatch({
            type: assignOperatorActions.GET_ALL_ASSIGNMENT_REQUEST,
            value: { idParent: parent.id },
        });
    }, [dispatch, parent.id]);

    const columns = useMemo(() => [
        {
            name: 'ID Address',
            selector: row => row.idaddress,
            sortable: true
        },
        {
            name: 'Usuario',
            selector: row => row.usuario_name,
            sortable: true,
        },
        {
            name: 'Operador',
            selector: row => row.company_name,
            sortable: true,
        },
        {
            name: 'Estado Actual',
            selector: row => row.cur_status,
            sortable: true,
        },
        {
            name: 'Intentos',
            selector: row => row.intents,
            sortable: true,
        },
        {
            name: 'Respuesta de Datos',
            cell: row => {
                const text = extractMessage(row.data_response)
                const contentString = JSON.stringify(text);
                const previewContent = contentString.length > 100 ? `${contentString.substring(0, 100)}...` : contentString;

                return (
                    <div title={contentString}>
                        {previewContent}
                    </div>
                );
            },
            width: '550px',
            sortable: true,
        },
        {
            name: 'Fecha',
            selector: row => row.createdAt,
            sortable: true,
            format: row => new Date(row.createdAt).toLocaleDateString(),
        },
    ]);

    useEffect(() => {
        getData(page, perPage);
    }, [page, perPage]);

    useEffect(() => {
        let interval = null;

        if (isActive) {
            interval = setInterval(() => {
                getData()
            }, intervalDuration);
        } else if (!isActive && interval) {
            clearInterval(interval);
        }

        return () => clearInterval(interval);
    }, [isActive, intervalDuration, activeTab]);

    return (
        <>
            <div className="d-flex justify-content-start align-items-end py-2">
                <div className="mr-5 mb-2">
                    <Button onClick={handleDetail}>ir atrás</Button>
                </div>
                <div className="mr-5 mb-2">
                    <span>Listado de Asignaciones fallidas</span>
                </div>
                {/*<div className="mr-2 mb-2">*/}
                {/*    <span style={{ cursor: 'pointer' }} onClick={() => setIsActive(!isActive)}>*/}
                {/*        <FiZap color={isActive ? 'blue' : 'gray'} title={isActive ? "Recarga Automatica Activa" : "Activar Recarga Automatica"} size={30} />*/}
                {/*    </span>*/}
                {/*</div>*/}
                <div className="mr-2 mb-2">
                    {/*<label>Frecuencia</label>*/}
                    {/*<select disabled={!isActive} className="custom-select" value={intervalDuration} onChange={(e) => setIntervalDuration(e.target.value)}>*/}
                    {/*    <option value="30000">cada 30 segundos</option>*/}
                    {/*    <option value="60000">cada minuto</option>*/}
                    {/*</select>*/}
                </div>
                <div className="mr-2">
                    <Form.Control
                        id="search"
                        type="text"
                        placeholder="Buscar..."
                        aria-label="Buscar"
                        value={filterText}
                        onChange={e => setFilterText(e.target.value)}
                        style={{ marginBottom: '10px' }}
                    />
                </div>
            </div>

            <DataTable
                columns={columns}
                data={filteredData}
                progressPending={processingGetAllAssignment}
                noDataComponent={<h6>No hay datos para listar</h6>}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                //onChangePage={handlePageChange}
                paginationRowsPerPageOptions={[10, 15, 20, 25, 30]}
                actions={actionsMemo}
            />
        </>
    )

}